import { render, staticRenderFns } from "./ReviewsList.vue?vue&type=template&id=a4fbf466&"
import script from "./ReviewsList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewsList.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4fbf466')) {
      api.createRecord('a4fbf466', component.options)
    } else {
      api.reload('a4fbf466', component.options)
    }
    module.hot.accept("./ReviewsList.vue?vue&type=template&id=a4fbf466&", function () {
      api.rerender('a4fbf466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsList.vue"
export default component.exports